/** Rappel qualitatif d'hydratation quand une séance a été enregistrée aujourd'hui.
 * Sans chiffre : aucune source publique ne quantifie une compensation kcal→ml. */
import { type Exercise, HYDRATION_EXERCISE_NOTE, hasLoggedSessionOn } from '@/domain';

interface Props {
  exercises: readonly Exercise[];
}

export function SportHydrationNote({ exercises }: Props) {
  if (!hasLoggedSessionOn(exercises)) return null;

  return (
    <div
      className="card"
      style={{
        borderLeft: '4px solid var(--accent)',
        background: 'color-mix(in srgb, var(--accent) 10%, var(--surface-1))',
        marginBottom: '1rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.6rem',
      }}
      role="status"
    >
      <span style={{ fontSize: '1.2rem' }}>💧</span>
      <span>
        {HYDRATION_EXERCISE_NOTE.text}{' '}
        <span className="muted" style={{ fontSize: '0.82rem' }}>
          ({HYDRATION_EXERCISE_NOTE.source})
        </span>
      </span>
    </div>
  );
}
